/* Before and after care — English version. General precautions, no promise
 * of results, not a substitute for a consultation. */

const conseilsEn = {
    eyebrow: "Preparing for and recovering from a treatment",
    h1: "Advice before and after a treatment",
    lead: "A well-prepared treatment goes more smoothly and recovers faster. Here are the precautions we go through in consultation, gathered so that you can read them again at home. They do not replace the personalised instructions given by the doctor, which always take precedence.",
    beforeTitle: "Before any session",
    beforeLead:
        "These rules apply to every treatment carried out at the clinic, from a peel to laser hair removal:",
    beforeItems: [
        "tell us about any pregnancy, breastfeeding or ongoing treatment, including food supplements and prescribed creams",
        "tell us about recurrent cold sores, a history of raised scars or an autoimmune condition: some procedures need preparation or must be postponed",
        "come without make-up, and without perfume or self-tanner on the area to be treated",
        "avoid sun exposure and sunbeds in the two weeks beforehand",
        "let us know if you have had a vaccination or an aesthetic treatment elsewhere in the past fortnight",
        "plan an easy slot afterwards: no intense exercise, no sauna, no important event that same evening",
    ],
    laserTitle: "Before laser hair removal or electrolysis",
    laserItems: [
        "shave the area the day before or that morning: the hair must be present under the skin, but not above it",
        "no waxing, tweezing or threading in the four preceding weeks — the laser needs the root",
        "no self-tanner for two weeks, and no recent tan on the area",
        "stop scrubs and exfoliating actives two to three days before",
        "tell us if you are taking a photosensitising medicine; some antibiotics are among them",
    ],
    peelTitle: "Before a peel, microneedling or mesotherapy",
    peelItems: [
        "pause retinoids, acids and scrubs five to seven days before, unless the doctor says otherwise",
        "report any current or recent isotretinoin treatment",
        "book the session away from an important event: redness and peeling are possible for a few days",
        "moisturise your skin well in the preceding days — supple skin reacts better",
        "if you have recurrent cold sores, preventive treatment may be prescribed before a facial treatment",
    ],
    injTitle: "Before injections",
    injItems: [
        "avoid aspirin, ibuprofen and supplements that thin the blood in the preceding days, unless they are prescribed to you — never stop a treatment on your own",
        "avoid alcohol the night before, it increases bruising",
        "eat normally before you come",
        "do not plan injections in the week of a wedding, a trip or an important photo",
        "tell us about any planned or recent dental work, which may justify postponing the session",
    ],
    afterTitle: "After the session",
    afterParagraphs: [
        "Almost every treatment has some after-effects: redness, warmth, slight swelling, small bruises after injections, peeling after a chemical peel. They are usual, temporary, and are explained to you before the session. What matters afterwards is leaving the skin alone.",
        "For forty-eight hours, avoid heat and friction. Do not scratch, do not exfoliate and do not pull off flaking skin: that is how marks are avoided.",
    ],
    afterItems: [
        "no intense exercise, steam room, sauna, swimming pool or hot bath for 48 hours",
        "gentle cleansing, a simple moisturiser, and no new product in the following days",
        "no make-up on the area for 24 hours after microneedling, mesotherapy or injections",
        "high sun protection every day, even when it is cloudy",
        "no massage or pressure on an injected area, unless the doctor says otherwise",
        "drink normally and sleep with your head slightly raised the first night after facial injections",
    ],
    soleilTitle: "The sun, the real issue",
    soleilParagraphs: [
        "Sun protection is not a comfort detail: it is what protects the benefit of a treatment. On skin made fragile by a peel, a laser or microneedling, even brief exposure can leave a lasting mark, particularly on pigmented skin and where there is melasma.",
        "Apply a high factor in the morning and reapply during the day if you are exposed, all year round, including behind glass. A hat, sunglasses and shade usefully complete the cream in the weeks following a treatment.",
    ],
    alerteTitle: "When to get back in touch",
    alerteLead:
        "Most after-effects settle on their own. Contact the clinic, or a doctor if you cannot reach the clinic, if you notice:",
    alerteItems: [
        "pain that increases instead of easing after 48 hours",
        "spreading redness, a hot area, or a fever",
        "a blister, a thick crust or a wound that does not close",
        "an area that turns pale or purple, or loses sensation, after an injection",
        "anything that worries you and that we had not discussed",
    ],
    alerteFin:
        "In a medical emergency, do not wait for a reply: call 15 or 112, or go to the nearest emergency department. The clinic does not provide emergency care.",
    faqTitle: "Frequently asked questions about recovery",
    faq: [
        [
            "Can I wear make-up after a session?",
            "After a superficial peel, usually yes from the next day. After microneedling, mesotherapy or injections it is better to wait twenty-four hours: the skin has micro-openings and make-up increases the risk of irritation. The exact instruction is given to you at the end of the session.",
        ],
        [
            "How long do bruises last after an injection?",
            "When a bruise appears, it usually fades within five to ten days, sometimes a little longer on the lips and under the eyes. It covers very well with concealer once the skin has closed.",
        ],
        [
            "Can I exercise the same day?",
            "It is better to avoid it for forty-eight hours. Exercise increases heat, sweating and blood flow, three factors that worsen redness, swelling and the risk of bruising.",
        ],
        [
            "What should I do if my skin peels after a peel?",
            "That is the intended effect. Let it happen: gentle cleansing, moisturiser, sun protection, and above all do not pull the skin off, even the pieces that hang. Pulling them off is the surest way to leave a mark.",
        ],
        [
            "Does this advice replace a consultation?",
            "No. It gives the general framework for the treatments carried out at the clinic. Your own instructions depend on your skin, your treatments and the procedure performed: only those given to you in consultation apply.",
        ],
    ],
};

export default conseilsEn;
